import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import cloneDeep from "lodash/cloneDeep";
import { connect } from "react-redux";
import {Alert, Layout, Input, Table, Button, Modal, Badge, Icon} from "antd";


import ProfileUploadForm from "../../components/ProfileUploadForm/ProfileUploadForm";
import ScheduleUploadForm from "../../components/ScheduleUploadForm/ScheduleUploadForm";
import ScheduleUpload3Form from "../../components/ScheduleUpload3Form/ScheduleUpload3Form";
import ScheduleUpload1Form from "../../components/ScheduleUpload1Form/ScheduleUpload1Form";
import ScheduleUploadEcoaForm from "../../components/ScheduleUploadEcoaForm/ScheduleUploadEcoaForm";
import ImednetScheduleForm from "../../components/ImednetScheduleForm/ImednetScheduleForm";
import ImednetSchedule2Form from "../../components/ImednetSchedule2Form/ImednetSchedule2Form";
import ImednetSchedule3Form from "../../components/ImednetSchedule3Form/ImednetSchedule3Form";
import DatafaxPushForm from "../../components/DatafaxForms/DatafaxPushForm";
import DatafaxPullForm from "../../components/DatafaxForms/DatafaxPullForm";
import DatafaxVisitsForm from "../../components/DatafaxForms/DatafaxVisitsForm";
import classes from "./ProfileList.css";

import isAuthenticated from "../../utils/isAuthenticated";
import { getProfileUploadsSearchRequest } from "../../api/requests";

import { logout } from "../../reducers/user/actions";
import {
  getSubjectProfileUploadCreatePermission,
  getApiIbmReadPermission,
  getApiEcoaReadPermission,
  getApiImednetReadPermission,
  getApiDatafaxReadPermission,
  getUserTimezone,
  getUserShortTimezone,
} from "../../reducers/user/selectors";
import moment from "moment";
import { withNamespaces } from "react-i18next";

const { Content } = Layout;
const { Search } = Input;

class ProfileList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      profiles: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      site: null,
      filter: null,
      order: "descend",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: {
        columnKey: "id",
        field: "id",
        order: "descend",
      },
      profileEdit: null,
      filterBy: null,
      filterValue: null,
      filtersBy: ["location"],
      filtersValue: [],
      approvedSelected: null,
      profileItem: null,
      profileID: "",
      trackingNumber: "",
      isSendingToPatient: false,
      scheduleUploadEcoaShow: false,
      scheduleImednetShow: false,
      scheduleImednet2Show: false,
      scheduleImednet3Show: false,
      scheduleUpload2Show: false,
      scheduleUpload1Show: false,
      scheduleUpload3Show: false,
      scheduleDatafax1Show: false,
      scheduleDatafax2Show: false,
      scheduleDatafax3Show: false,
      comments: [],
      errors: '',
    };
  }

  async componentDidMount() {
    this.onNameSearch();
  }

  onNameSearch = async (value) => {
    this.setState(
      {
        nameSearch: value,
        filterBy: null,
        filterValue: null,
        eventsSelected: {},
        currentPage: 1,
      },
      this.getProfiles
    );
  };

  getProfiles = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getProfileUploadsSearchRequest({
        nameSearch: this.state.nameSearch,
        order_direction: this.state.order,
        page,
        per_page,
        order_column: get(this.state, "sortedInfo.columnKey"),
        // filter_by: this.state.filtersBy,
        // filter_value: this.state.filtersValue,
        // filter_approve: this.state.approvedSelected !== null ? this.state.approvedSelected : null,
      });

      if (Array.isArray(data.data)) {
        this.setState({
          profiles: data.data,
          total: data.total_pages * per_page,
          currentPage: page,
        });
      } else {
        this.setState({
          profiles: [data],
          total: 1 * per_page,
          currentPage: page,
        });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        profiles: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getProfiles(pagination.current, pagination.pageSize)
    );
  };

  onProfileEditSubmit = () => {
    this.setState({ profileEdit: null }, this.getProfiles);
  };

  addDrug = () => {
    this.setState({ profileEdit: {} });
  };

  onProfileEditHide = () => {
    this.setState({ profileEdit: null });
  };

  // handleFilterChange = index => value => {
  //   this.setState(state => {
  //     const filtersBy = cloneDeep(state.filtersBy);
  //     const filtersValue = cloneDeep(state.filtersValue);
  //     filtersBy[index] = value;
  //     delete filtersValue[index];
  //     return { filtersBy, filtersValue };
  //   });
  // };
  // handleFilterValueChange = index => value => { this.setState(state => {
  //   const filtersValue = cloneDeep(state.filtersValue);
  //   filtersValue[index] = value;
  //   return { filtersValue };
  // }, this.getProfiles) };

  clearFilter = (index) => () => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);

      filtersBy.splice(index, 1);
      filtersValue.splice(index, 1);

      return { filtersBy, filtersValue };
    }, this.getProfiles);
  };

  clearFilters = () => {
    this.setState({ nameSearch: null, filtersValue: [] }, this.getProfiles);
  };

  schedule2Show = () => {
    this.setState({ scheduleUpload2Show: true });
  };

  onScheduleUpload2Hide = () => {
    this.setState({ scheduleUpload2Show: false });
  };

  schedule3Show = () => {
    this.setState({ scheduleUpload3Show: true });
  };

  onScheduleUpload3Hide = () => {
    this.setState({ scheduleUpload3Show: false });
  };

  schedule1Show = () => {
    this.setState({ scheduleUpload1Show: true });
  };

  onScheduleUpload1Hide = () => {
    this.setState({ scheduleUpload1Show: false });
  };

  scheduleEcoaShow = () => {
    this.setState({ scheduleUploadEcoaShow: true });
  };

  onScheduleUploadEcoaHide = () => {
    this.setState({ scheduleUploadEcoaShow: false });
  };

  scheduleImednetShow = () => {
    this.setState({ scheduleImednetShow: true });
  };

  scheduleImednetHide = () => {
    this.setState({ scheduleImednetShow: false });
  };

  onScheduleUploadSubmit = () => {
    this.onScheduleUpload2Hide();
  };

  onScheduleUpload3Submit = () => {
    this.onScheduleUpload3Hide();
  };

  onScheduleUpload1Submit = () => {
    this.onScheduleUpload1Hide();
  };

  onScheduleUploadEcoaSubmit = () => {
    this.onScheduleUploadEcoaHide();
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      nameSearch,
      comments,
      currentPage,
      profiles,
      total,
      pageSize,
      profileEdit,
      sortedInfo,
      scheduleUpload1Show,
      scheduleUpload2Show,
      scheduleUploadEcoaShow,
      scheduleUpload3Show,
      scheduleImednetShow,
      scheduleImednet2Show,
      scheduleImednet3Show,
      scheduleDatafax1Show,
      scheduleDatafax2Show,
      scheduleDatafax3Show,
      errors,
    } = this.state;
    const {
      subjectProfileUploadCreatePermission,
      apiIbmReadPermission,
      apiEcoaReadPermission,
      apiImednetReadPermission,
      apiDatafaxReadPermission,
    } = this.props;

    let columns = [
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t("ID"),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "id" && sortedInfo.order,
        render: (val, row) => (
          <div>
            {val} &nbsp;
            {row.status === "green" && (
              <Badge
                count="Success"
                style={{
                  backgroundColor: "#49c850",
                }}
              />
            )}
            {row.status === "red" && (
              <Badge
                count="Error"
                style={{
                  backgroundColor: "#FF4040FF",
                }}
              />
            )}
            {row.status === "orange" && (
              <Badge
                count="Warning"
                style={{
                  backgroundColor: "#FF9800FF",
                }}
              />
            )}
            {row.status === "gray" && (
              <Badge
                count="-"
                style={{
                  backgroundColor: "#8B8B8D7F",
                }}
              />
            )}
          </div>
        ),
      },
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t("Name"),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "name" && sortedInfo.order,
      },
      {
        dataIndex: "created",
        key: "created",
        title: this.props.i18n.t("Created"),
        render: (val) => (
          <div>
            {moment
              .utc(val)
              .tz(this.props.userTimezone || "UTC")
              .format("YYYY-MM-DD HH:mm")}
            &nbsp;
            {this.props.userShortTimezone || "UTC"}
          </div>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "created" && sortedInfo.order,
      },
      {
        dataIndex: "upload_type",
        key: "upload_type",
        title: this.props.i18n.t("NamespaceProfileList:Upload type"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "upload_type" && sortedInfo.order,
      },
      {
        dataIndex: "total_new_profiles",
        key: "total_new_profiles",
        title: this.props.i18n.t("NamespaceProfileList:New #"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "total_new_profiles" &&
          sortedInfo.order,
      },
      {
        dataIndex: "total_updated_profiles",
        key: "total_updated_profiles",
        title: this.props.i18n.t("NamespaceProfileList:Updated #"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "total_updated_profiles" &&
          sortedInfo.order,
      },
      {
        dataIndex: "total_skipped_profiles",
        key: "total_skipped_profiles",
        title: this.props.i18n.t("NamespaceProfileList:Skipped #"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "total_skipped_profiles" &&
          sortedInfo.order,
      },
      {
        dataIndex: "total_failed_profiles",
        key: "total_failed_profiles",
        title: this.props.i18n.t("NamespaceProfileList:Failed #"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "total_failed_profiles" &&
          sortedInfo.order,
      },
      {
        dataIndex: "total_profiles",
        key: "total_profiles",
        title: this.props.i18n.t("NamespaceProfileList:Total #"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "total_profiles" && sortedInfo.order,
      },

      {
        dataIndex: "uploaded_by_username",
        key: "uploaded_by_username",
        title: this.props.i18n.t("NamespaceProfileList:Uploaded by username"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "uploaded_by_username" &&
          sortedInfo.order,
      },
      {
        dataIndex: "comments",
        key: "comments",
        title: this.props.i18n.t("Comments"),
        render: (val, row) => {
          let comments = ""
          if (Array.isArray(val)){
            comments = val;
          }
          if (val.length > 300){
            if (val.includes('\n')){
              comments = val.split("\n");
            } else if (val.includes(';')){
              comments = val.split(";");
            } else if (val.includes('.')){
              comments = val.split(".");
            }
          }else{
            comments = [val];
          }

          return (
            <div style={{ maxWidth: "250px" }}>
              {map(
                comments.slice(0, 3),
                (comment, i) => comment && <p key={i}>{comment}.</p>
              )}
              {comments.length > 4 && (
                <p>
                  <Button
                    size="small"
                    type="primary"
                    onClick={() =>
                      this.setState({ comments: comments })
                    }
                  >
                    {this.props.i18n.t(
                      "NamespaceProfileList:Show all comments"
                    )}
                  </Button>
                </p>
              )}
              {row.errors && row.errors.length && (
                <p>
                  <Button
                    size="small"
                    type="danger"
                    onClick={() =>
                      this.setState({ errors: row.errors })
                    }
                  >
                    {this.props.i18n.t(
                      "NamespaceProfileList:Show errors"
                    )}
                  </Button>
                </p>
              )}
            </div>
          );
        },
      },
    ];

    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("API Management")}
            </h3>

            <div className={classes.searchWrapper}>
              <label className={classes.searchWrapperSearch}>
                <b className={classes.searchWrapperLabel}>
                  {this.props.i18n.t("SEARCH")}
                </b>
                <Search
                  placeholder={this.props.i18n.t("By name")}
                  enterButton={this.props.i18n.t("Search")}
                  size="large"
                  onSearch={this.onNameSearch}
                  value={nameSearch}
                  onChange={this.onNameChange}
                  style={{ maxWidth: "500px" }}
                />
              </label>

              <span className={classes.clearButton} onClick={this.clearFilters}>
                {this.props.i18n.t("Clear")}
              </span>
            </div>

            {errorMessage && (
              <Alert
                type="error"
                message={errorMessage}
                className={classes.alert}
              />
            )}

            {responseMessage && (
              <Alert
                type="success"
                message={responseMessage}
                className={classes.alert}
              />
            )}

            <div className={classes.actionWrapper}>
              <div>
                {subjectProfileUploadCreatePermission && (
                  <Button
                    type="primary"
                    onClick={this.addDrug}
                    style={{ margin: "10px 10px 0 0" }}
                  >
                    {this.props.i18n.t("NamespaceProfileList:Upload patients")}
                  </Button>
                )}
                &nbsp;
                {apiIbmReadPermission && (
                  <Button
                    type="primary"
                    onClick={this.schedule1Show}
                    style={{ margin: "10px 10px 0 0" }}
                  >
                    {this.props.i18n.t(
                      "NamespaceProfileList:IBM EDC API 1 Settings"
                    )}
                  </Button>
                )}
                {apiIbmReadPermission && (
                  <Button
                    type="primary"
                    onClick={this.schedule2Show}
                    style={{ margin: "10px 10px 0 0" }}
                  >
                    {this.props.i18n.t(
                      "NamespaceProfileList:IBM EDC API 2 Settings"
                    )}
                  </Button>
                )}
                {apiIbmReadPermission && (
                  <Button
                    type="primary"
                    onClick={this.schedule3Show}
                    style={{ margin: "10px 10px 0 0" }}
                  >
                    {this.props.i18n.t(
                      "NamespaceProfileList:IBM EDC API 3 Settings"
                    )}
                  </Button>
                )}
                {apiEcoaReadPermission && (
                  <Button
                    type="primary"
                    onClick={this.scheduleEcoaShow}
                    style={{ margin: "10px 10px 0 0" }}
                  >
                    {this.props.i18n.t(
                      "NamespaceProfileList:Ecoa Integration EDC API Settings"
                    )}
                  </Button>
                )}
                {apiImednetReadPermission && (
                  <Button
                    type="primary"
                    onClick={this.scheduleImednetShow}
                    style={{ margin: "10px 10px 0 0" }}
                  >
                    {this.props.i18n.t(
                      "NamespaceProfileList:iMednet EDC API 1 Settings"
                    )}
                  </Button>
                )}
                {apiImednetReadPermission && (
                  <Button
                    type="primary"
                    onClick={() => {
                      this.setState({ scheduleImednet2Show: true });
                    }}
                    style={{ margin: "10px 10px 0 0" }}
                  >
                    {this.props.i18n.t(
                      "NamespaceProfileList:iMednet EDC API 2 Settings"
                    )}
                  </Button>
                )}
                {apiImednetReadPermission && (
                  <Button
                    type="primary"
                    onClick={() => {
                      this.setState({ scheduleImednet3Show: true });
                    }}
                    style={{ margin: "10px 10px 0 0" }}
                  >
                    {this.props.i18n.t(
                      "NamespaceProfileList:iMednet EDC API 3 Settings"
                    )}
                  </Button>
                )}
                {apiDatafaxReadPermission && (
                  <Button
                    type="primary"
                    onClick={() => {
                      this.setState({ scheduleDatafax1Show: true });
                    }}
                    style={{ margin: "10px 10px 0 0" }}
                  >
                    {this.props.i18n.t(
                      "NamespaceProfileList:Datafax EDC API 1 Settings"
                    )}
                  </Button>
                )}
                {apiDatafaxReadPermission && (
                  <Button
                    type="primary"
                    onClick={() => {
                      this.setState({ scheduleDatafax2Show: true });
                    }}
                    style={{ margin: "10px 10px 0 0" }}
                  >
                    {this.props.i18n.t(
                      "NamespaceProfileList:Datafax EDC API 2 Settings"
                    )}
                  </Button>
                )}
                {apiDatafaxReadPermission && (
                  <Button
                    type="primary"
                    onClick={() => {
                      this.setState({ scheduleDatafax3Show: true });
                    }}
                    style={{ margin: "10px 10px 0 0" }}
                  >
                    {this.props.i18n.t(
                      "NamespaceProfileList:Datafax EDC API 3 Settings"
                    )}
                  </Button>
                )}
              </div>
            </div>

            <Table
              columns={columns}
              dataSource={profiles}
              loading={isLoading}
              rowKey="id"
              onChange={this.handleTableChange}
              pagination={{
                onShowSizeChange: (current, size) => {
                  this.setState({ pageSize: size });
                },
                current: currentPage,
                total,
                pageSize,
                showSizeChanger: true,
                pageSizeOptions: ["10", "25", "50", "100"],
                position: 'both',
              }}
            />

            {/*{isLoading && <Icon type="loading" />}*/}

            <Modal
              visible={!!profileEdit}
              onCancel={this.onProfileEditHide}
              footer={null}
            >
              {profileEdit && (
                <ProfileUploadForm
                  onSubmit={this.onProfileEditSubmit}
                  onCancel={this.onProfileEditHide}
                />
              )}
            </Modal>

            <Modal
              visible={!!scheduleUpload2Show}
              onCancel={this.onScheduleUpload2Hide}
              footer={null}
            >
              {scheduleUpload2Show && (
                <ScheduleUploadForm
                  onSubmit={this.onScheduleUploadSubmit}
                  onCancel={this.onScheduleUpload2Hide}
                />
              )}
            </Modal>

            <Modal
              visible={!!scheduleImednetShow}
              onCancel={() => {
                this.setState({ scheduleImednetShow: false });
              }}
              footer={null}
            >
              {scheduleImednetShow && (
                <ImednetScheduleForm
                  onSubmit={() => {
                    this.setState({ scheduleImednetShow: false });
                  }}
                  onCancel={() => {
                    this.setState({ scheduleImednetShow: false });
                  }}
                />
              )}
            </Modal>

            <Modal
              visible={!!scheduleImednet2Show}
              onCancel={() => {
                this.setState({ scheduleImednet2Show: false });
              }}
              footer={null}
            >
              {scheduleImednet2Show && (
                <ImednetSchedule2Form
                  onSubmit={() => {
                    this.setState({ scheduleImednet2Show: false });
                  }}
                  onCancel={() => {
                    this.setState({ scheduleImednet2Show: false });
                  }}
                />
              )}
            </Modal>

            <Modal
              visible={!!scheduleImednet3Show}
              onCancel={() => {
                this.setState({ scheduleImednet3Show: false });
              }}
              footer={null}
            >
              {scheduleImednet3Show && (
                <ImednetSchedule3Form
                  onSubmit={() => {
                    this.setState({ scheduleImednet3Show: false });
                  }}
                  onCancel={() => {
                    this.setState({ scheduleImednet3Show: false });
                  }}
                />
              )}
            </Modal>

            <Modal
              visible={!!scheduleUpload3Show}
              onCancel={this.onScheduleUpload3Hide}
              footer={null}
            >
              {scheduleUpload3Show && (
                <ScheduleUpload3Form
                  onSubmit={this.onScheduleUpload3Submit}
                  onCancel={this.onScheduleUpload3Hide}
                />
              )}
            </Modal>

            <Modal
              visible={!!scheduleUpload1Show}
              onCancel={this.onScheduleUpload1Hide}
              footer={null}
            >
              {scheduleUpload1Show && (
                <ScheduleUpload1Form
                  onSubmit={this.onScheduleUpload1Submit}
                  onCancel={this.onScheduleUpload1Hide}
                />
              )}
            </Modal>

            <Modal
              visible={!!scheduleUploadEcoaShow}
              onCancel={this.onScheduleUploadEcoaHide}
              footer={null}
            >
              {scheduleUploadEcoaShow && (
                <ScheduleUploadEcoaForm
                  onSubmit={this.onScheduleUploadEcoaSubmit}
                  onCancel={this.onScheduleUploadEcoaHide}
                />
              )}
            </Modal>

            <Modal
              visible={!!scheduleDatafax1Show}
              onCancel={() => {
                this.setState({ scheduleDatafax1Show: false });
              }}
              footer={null}
            >
              {scheduleDatafax1Show && (
                <DatafaxPushForm
                  onSubmit={() => {
                    this.setState({ scheduleDatafax1Show: false });
                  }}
                  onCancel={() => {
                    this.setState({ scheduleDatafax1Show: false });
                  }}
                />
              )}
            </Modal>

            <Modal
              visible={!!scheduleDatafax2Show}
              onCancel={() => {
                this.setState({ scheduleDatafax2Show: false });
              }}
              footer={null}
            >
              {scheduleDatafax2Show && (
                <DatafaxPullForm
                  onSubmit={() => {
                    this.setState({ scheduleDatafax2Show: false });
                  }}
                  onCancel={() => {
                    this.setState({ scheduleDatafax2Show: false });
                  }}
                />
              )}
            </Modal>

            <Modal
              visible={!!scheduleDatafax3Show}
              onCancel={() => {
                this.setState({ scheduleDatafax3Show: false });
              }}
              footer={null}
            >
              {scheduleDatafax3Show && (
                <DatafaxVisitsForm
                  onSubmit={() => {
                    this.setState({ scheduleDatafax3Show: false });
                  }}
                  onCancel={() => {
                    this.setState({ scheduleDatafax3Show: false });
                  }}
                />
              )}
            </Modal>

            <Modal
              visible={!!comments.length}
              onCancel={() => this.setState({ comments: [] })}
              footer={null}
            >
              <h3>{this.props.i18n.t("Comments")}</h3>

              {map(
                comments,
                (comment, i) => comment && <p key={i}>{comment}.</p>
              )}
            </Modal>
            <Modal
              visible={!!errors}
              onCancel={() => this.setState({ errors: "" })}
              footer={null}
            >
              <h3>{this.props.i18n.t("Errors")}</h3>
              <p>{errors}</p>
            </Modal>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  subjectProfileUploadCreatePermission: getSubjectProfileUploadCreatePermission(
    state
  ),
  apiIbmReadPermission: getApiIbmReadPermission(state),
  apiImednetReadPermission: getApiImednetReadPermission(state),
  apiEcoaReadPermission: getApiEcoaReadPermission(state),
  apiDatafaxReadPermission: getApiDatafaxReadPermission(state),
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(ProfileList))
);



// WEBPACK FOOTER //
// ./src/containers/ProfileList/ProfileList.js